export const beneficiaryTenderOfferSelectorModalInitValue = {
  data: {
    selectedTenderOfferOption: null,
    tenderOfferOptions: [],
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeTenderOfferOption(): void {},
    handleSeeTenderOffer(): void {},
  },
};
